import { render, staticRenderFns } from "./BatteryChargeWidget.vue?vue&type=template&id=370a6b58&scoped=true&"
import script from "./BatteryChargeWidget.vue?vue&type=script&lang=js&"
export * from "./BatteryChargeWidget.vue?vue&type=script&lang=js&"
import style0 from "./BatteryChargeWidget.vue?vue&type=style&index=0&id=370a6b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370a6b58",
  null
  
)

export default component.exports